const ngExtracter = (data, address) => {
  const dataIsNested = address.includes(".");
  if (dataIsNested) {
    const allKeys = address.split(".");
    let properTxt = data;

    for (let i = 0; i < allKeys.length; i++) {
      const currentKey = allKeys[i];
      // console.log("properTxt[allKeys[allKeys.length - 1]]", properTxt[allKeys[allKeys.length - 1]]);
      if (i === allKeys.length - 1) {
        if (Array.isArray(properTxt[allKeys[allKeys.length - 1]])) {
          // console.log("isArr the last one");
          return properTxt[allKeys[allKeys.length - 1]];
          // const extractedValues = properTxt.map((item) => item[allKeys[allKeys.length - 1]]);
          // return extractedValues.join(",");
        } else if (typeof properTxt[allKeys[allKeys.length - 1]] === "string") {
          return properTxt[allKeys[allKeys.length - 1]];
        } else if (
          Object.prototype.toString.call(properTxt[allKeys[allKeys.length - 1]]) === "[object Object]"
        ) {
          if ("id" in properTxt[allKeys[allKeys.length - 1]]) {
            return properTxt[allKeys[allKeys.length - 1]];
          }
        }
        // else if ("id" in properTxt[allKeys[allKeys.length - 1]]) {
        //   return properTxt[allKeys[allKeys.length - 1]];
        // }
        else if (properTxt[allKeys[allKeys.length - 1]] === null) {
          return null;
        } else {
          return "we reached an object at last";
        }
      } else {
        if (Array.isArray(properTxt[currentKey])) {
          return properTxt[currentKey];
          // const extractedValues = properTxt.map((item) =>
          //   ngExtracter(item[currentKey], allKeys.slice(i + 1).join("."))
          // );
          // return extractedValues.join(",");
        } else if (properTxt && typeof properTxt === "object" && currentKey in properTxt) {
          properTxt = properTxt[currentKey];
        } else {
          return "wrong Address , key does'nt exist";
        }
      }
    }
  } else {
    return data[address];
  }
};

export default ngExtracter;
